import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { TrainersModel } from "./trainers-data.model";

export class TrainersGridModel extends TrainersModel { }

export class TrainersListingModel extends GridModel<TrainersGridModel> { }
export class TrainersGridParams extends GridPostParams {
  pageNumber:any= 1;
  pageSize:any= 10;
  search_keyword:any= '';
  direction:any= '';
  column:any= '';
  // user_id:any= 2;
}